const BALTIC_BORN_ID = "660ad5117bf2630007bcca40";
const DONAJO_ID = "6621a1d66a0dd10007318ddf";
const BECAUSE_TEES_ID = "66c74804e0beeb6204a761a6";
const INKOPIOUS_ID = "66c74a216f719cb3b7391e07";

export enum TeamCustomLayout {
  BALTIC_BORN_ID = "BALTIC_BORN_ID",
  DONAJO_ID = "DONAJO_ID",
  BECAUSE_TEES_ID = "BECAUSE_TEES_ID",
  INKOPIOUS_ID = "INKOPIOUS_ID",
}

const teamIdToTeamCustomLayout = new Map([
  [BALTIC_BORN_ID, TeamCustomLayout.BALTIC_BORN_ID],
  [DONAJO_ID, TeamCustomLayout.DONAJO_ID],
  [BECAUSE_TEES_ID, TeamCustomLayout.BECAUSE_TEES_ID],
  [INKOPIOUS_ID, TeamCustomLayout.INKOPIOUS_ID],
]);

export const getTeamCustomLayout = (
  teamId: string,
): TeamCustomLayout | undefined => {
  return teamIdToTeamCustomLayout.get(teamId);
};
